module.exports = "<span class={{item.status}}>\n  <a class=\"msg\">\n    <img src={{item.image}} alt=\"\" class=\"air air-top-left margin-top-5\" width=\"40\"\n         height=\"40\"/>\n    <span class=\"from\">{{item.title}}</span>\n    <span>{{item.time}}</span>\n    <span class=\"subject\">{{item.subject}}</span>\n    <span class=\"msg-body\">{{item.message}}</span>\n  </a>\n</span>\n"


//////////////////
// WEBPACK FOOTER
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/header/activities/activities-message/activities-message.component.html
// module id = ../../../../../src/app/shared/layout/header/activities/activities-message/activities-message.component.html
// module chunks = main